export default {
  overview: {
    padding: 20,
  },
  row: {
    display: 'flex',
    flex: 1,
    flexDirection: 'row',
  },
  logo: {
    // maxWidth: 200,
    // maxHeight: 200,
    // margin: 10,
    // padding: 10,
    textAlign: 'center',
  },
  chip: {
    margin: 10,
    // padding: 10,
  },
  addTag: {
    margin: 10,
  },
  tabContainer: {
    padding: 10,
  },
  tagsHeader: {
    display: 'flex',
    alignItems: 'center',
    marginTop: 10,
  },
  tagsLabel: {
    flex: 1,
    fontSize: '12px',
    paddingLeft: '2px',
    color: 'rgba(0, 0, 0, 0.3)',
  },
  tab: {
    height: 450,
  },
};



// WEBPACK FOOTER //
// ./src/components/Customers/CustomerDialog/styles.js